<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <el-button
        v-if="showAddJA"
        small
        class="mb-3"
        color="primary"
        icon="pridėti"
        title="Pridėti asmenį"
        :loading="loading"
        @click.native.stop="newPerson()"
      />
      <el-button
        v-if="showAddPersonBtn"
        small
        class="mb-3 ml-2"
        color="primary"
        icon="pridėti"
        title="Pridėti duomenų teikėją"
        :loading="loading"
        @click.native.stop="AddPersonBtn()"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        disable-sort
        class="mb-4 custom-table"
        :loading="loading"
        :headers="headers"
        :items="personsList"
        :hide-default-footer="true"
        :items-per-page="1000"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal'),
        }"
      >
          <!-- custom templates -->
          <template v-slot:item="{ item }">
            <tr>
              <td style="white-space: nowrap">
                <v-icon v-if="item.type == 'FIZ'">mdi-circle-small</v-icon>
                {{ item.code || item.iltu_code }}
              </td>
              <td>{{ item.fullname }}</td>
              <td>{{ item.other_info }}</td>
              <td v-if="!contactLoading"><person-contact-row :item="item"></person-contact-row></td>
              <td>
                <template>
                  <div class="nowrap">
                    <el-table-action
                      :item="setEditProPrincipal(item)"
                      @addJurRepresenterItem="newJurRepresenter(item)"
                      @editContacts="editContacts(item)"
                      @deleteItem="deleteItem({ item, type: 'pro_principals' })"
                    />
                  </div>
                </template>
              </td>
            </tr>
            <template v-for="(representer, index) in item.jur_representers">
              <tr :key="`${item.id}-${index}-representer`">
                <td style="white-space: nowrap">
                  <v-icon>mdi-circle-small</v-icon>
                  <span>{{ representer.code || representer.iltu_code }}</span>
                </td>
                <td>{{ representer.fullname }}</td>
                <td v-if="representer.other_info">{{`${item.fullname} ${$t('atstovas')} (${representer.other_info})`}}</td>
                <td v-else>{{ `${item.fullname} ${$t('atstovas')}` }}</td>
                <td v-if="!contactLoading"><person-contact-row :item="representer"></person-contact-row></td>
                <td>
                  <!-- CAN'T DELETE YET -->
                  <template>
                    <div class="nowrap">
                      <el-table-action
                        :item="setEditRepresenter(representer)"
                        @editContacts="editContacts(representer)"
                        @deleteItem="deleteItem({ representer, type: 'jur_representers', proPrincipalAmnId: item.amn_id })"
                      />
                    </div>
                  </template>
                </td>
              </tr>
            </template>
          </template>


      
        <!-- <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-table-action
              :item="setEdit(item, 'pro_principals')"
              @deleteItem="deleteItem({ item, type: 'pro_principals' })"
            />
          </div>
        </template> -->
      </v-data-table>
      <!-- <el-radio-group
        class="mt-0"
        inline
        v-if="showOperationPersonsType"
        v-model="formData.pro_principals_together"
        :items="togetherList"
        required
      >
      </el-radio-group> -->
    </v-col>
    <!-- modal  -->
    <modal-delete
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      :additionalData="formData"
      @addPersonData="addPerson"
      :parentAmnId="principalRepresenterId"
      @publicPersonWarning="publicPersonWarning"
      showCode
    />
    <modal-contact-form 
      v-if="showContactModal"
      v-model="showContactModal"
      :item="selectedContact"
      @reloadContact="reloadContact"
    />
    <modal-public-person-warning
      v-if="showPublicPersonWarning"
      v-model="showPublicPersonWarning"
      @continuePublicPerson="continueWithPublicPerson"
      @cancelPublicPerson="closePublicPersonWarning"
    />
  </v-row>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalContactForm from '@/components/modals/ModalContactForm.vue'
import PersonContactRow from '@/components/iregTableRows/PersonContactRow.vue'
import ModalPublicPersonWarning from '@/components/modals/ModalPublicPersonWarning.vue'

export default {
  name: 'IssuedPersonsForm',
  components: {
    ModalAddPerson,
    ModalDelete,
    ModalContactForm,
    PersonContactRow,
    ModalPublicPersonWarning,
  },
  props: {
    formData: [Array, Object],
    signatures: [Object, Array],
    showOnly: Boolean,
    onlyView: Boolean,
    canEditContacts: Boolean,
    customOtherInfo: [String],
  },
  data() {
    return {
      showContactModal: false,
      selectedContact: {},
      pageloading: false,
      loading: false,
      showAddPerson: false,
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      principalRepresenterId: null,
      contactLoading: false,
      showPublicPersonWarning: false,
      publicPersonData: null,
    }
  },

  computed: {
    personsList() {
      if (this.formData && this.formData.pro_principals.length) {
        return this.formData.pro_principals;
      } else if (this.signatures) {
        return this.signatures;
      }
      
      return [];
    },
    proPrincipalsInclude() {
      return (
        this.formData.pro_principals &&
        this.formData.pro_principals.filter(
          (item) => item.amn_id === this.formData.data_provider.amn_id
        ).length == 0
      ) 
    },
    showAddJA() {
      return !this.showOnly && !this.onlyView && this.formData && this.formData.pro_principals.length < 1
    },
    showAddPersonBtn(){
      return this.showAddJA && this.proPrincipalsInclude
    },
    togetherList() {
      return [
        { label: 'Veikimas kartu', value: true },
        { label: 'Veikimas atskirai', value: false },
      ]
    },
    showOperationPersonsType() {
      return this.formData.pro_principals?.length > 1
    },
    headers() {
      let headers = [
        {
          text: this.$t('Asmens kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė / Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
      return headers
    },
  },
  methods: {
    reloadContact() {
      this.contactLoading = true;
      this.$nextTick(() => {
        this.contactLoading = false
      })
    },
    setEditProPrincipal(item) {
      if (this.signatures) {
        this.$set(item, 'addJurRepresenter', (!(this.showOnly || this.onlyView) && item.type == 'JUR'))
        this.$set(item, 'canDelete', (!(this.showOnly || this.onlyView) && item.type == 'FIZ'))
        this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
      } else {
        if (item.type == 'JUR') {
          this.$set(item, 'addJurRepresenter', (this.showOnly || this.onlyView ? false : true))
        } else {
          this.$set(item, 'addJurRepresenter', false)
        }
        item.canDelete = this.showOnly || this.onlyView ? false : true
      }
      this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)

      return item
    },
    setEditRepresenter(representer) {
      representer.canDelete = this.showOnly || this.onlyView ? false : true
      representer.canEditContacts = this.canEditContacts
      return representer
    },
    editContacts(item) {
      item.phone_number_prepend = item.phone_number_prepend || '+370'
      item.phone_number = item.phone_number || ''
      item.email_address = item.email_address || ''
      this.selectedContact = item
      this.showContactModal = true
    },
    newJurRepresenter(item) {
      this.modalType = 'jur_representers'
      this.showAddPerson = this.showOnly || this.onlyView ? false : true
      this.principalRepresenterId = item.amn_id
    },
    setEdit(item, type) {
      if(this.showOnly || this.onlyView){
        item.canDelete = false
        return item
      }
      item.canDelete = true
      return item
    },
    newPerson() {
      this.modalType = this.signatures ? 'signatures' : 'pro_principals'
      this.showAddPerson = true
    },
    addPerson(item) {
      if (item.modalType === 'pro_principals') {
        item.jur_representers = item.signing_persons
        this.formData.pro_principals.push(item)
      } else if ((item.modalType === 'jur_representers' || item.modalType == undefined) && this.formData) {
          const index = this.formData.pro_principals.findIndex(
          (principal) => principal.amn_id === this.principalRepresenterId
        )
        if (typeof this.formData.pro_principals[index].jur_representers == 'undefined') {
          this.formData.pro_principals[index].jur_representers = []
        }
        //
        let exist = this.formData.pro_principals[index].jur_representers.filter(
          (representer) => representer.amn_id === item.amn_id
        ).length
        if (exist) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        //
        this.formData.pro_principals[index].jur_representers.push(item)
      } else if ((item.modalType === 'jur_representers' || item.modalType == undefined) && this.signatures) {
        // JA atšaukęs prokūra
        if (this.customOtherInfo) {
          item.other_info = this.customOtherInfo + ' ' + this.$t('atstovas') + (item.other_info ? ' (' + item.other_info + ')' : '')
        }

         let exist = this.signatures.filter(
          (representer) => representer.amn_id === item.amn_id
        ).length
        if (exist) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }

        this.signatures.push(item);
      } else {
        this.formData.pro_principals.push(item)
      }
      this.showAddPerson = false
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      if (item.type == 'jur_representers' && this.formData) {
        const index = this.formData.pro_principals.findIndex(
          (formItem) => formItem.amn_id === item.proPrincipalAmnId
        )
        const representersIndex = this.formData
                                        .pro_principals[index]
                                        .jur_representers
                                        .findIndex(formItem => formItem.amn_id === item.representer.amn_id)
        if (representersIndex > -1) {
          this.formData.pro_principals[index].jur_representers.splice(representersIndex, 1)
        }
      } else if (this.signatures) {
        const index = this.signatures.findIndex(
          (formItem) => formItem.amn_id === item.item.amn_id
        )
        if (index > -1) {
          this.signatures.splice(index, 1)
        }
      } else {
        const index = this.formData[item.type].findIndex(
          (formItem) => formItem.amn_id === item.item.amn_id
        )
        if (index > -1) {
          this.formData[item.type].splice(index, 1)
        }
      }
      this.showDelete = false
    },
    checkPerson(personData) {
      let code = personData.code
      let type = personData.type
      let dataType = personData.modalType == 'pro_principals' ? 'institution' : personData.modalType
      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType })
        .then(() => {
          this.addPerson(personData)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    AddPersonBtn() {
      this.loading = true
      let formData = this.formData.data_provider
      formData.dataType = 'pro_principals'
      let url = `persons/getByAsmCode`
      let personData = {}
      this.$axios
        .post(url, formData)
        .then((res) => {
          personData = res.data.person
          personData.type = this.formData.data_provider.type
          personData.modalType = 'pro_principals'
          if (personData.is_public) {
            this.publicPersonWarning(personData, true)
          } else {
            this.checkPerson(personData)
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
    },
    publicPersonWarning(personData) {
      this.showPublicPersonWarning = true
      this.publicPersonData = personData
    },
    continueWithPublicPerson() {
      if (this.publicPersonData) {
        this.checkPerson(this.publicPersonData)
      }
      this.closePublicPersonWarning()
    },
    closePublicPersonWarning() {
      this.publicPersonData = null
      this.loading = false
      this.showPublicPersonWarning = false
    }
  },
}
</script>

<style>
</style>